import React from 'react'

export const ChatHistoryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='49'
    height='48'
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_15873_70441'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='49'
      height='48'
    >
      <rect x='0.333984' width='48' height='48' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_15873_70441)'>
      <path
        d='M7.33398 39.577V12.231C7.33398 11.336 7.64865 10.5737 8.27798 9.944C8.90765 9.31467 9.66998 9 10.565 9H34.103C34.998 9 35.7603 9.31467 36.39 9.944C37.0193 10.5737 37.334 11.336 37.334 12.231V22.0345C37.1547 22.0192 36.988 22.0097 36.834 22.006C36.68 22.002 36.5133 22 36.334 22C36.1547 22 35.988 22.002 35.834 22.006C35.68 22.0097 35.5133 22.0192 35.334 22.0345V12.231C35.334 11.872 35.2187 11.577 34.988 11.346C34.757 11.1153 34.462 11 34.103 11H10.565C10.206 11 9.91098 11.1153 9.67998 11.346C9.44932 11.577 9.33398 11.872 9.33398 12.231V33H24.3685C24.3532 33.1793 24.3437 33.346 24.34 33.5C24.336 33.654 24.334 33.8207 24.334 34C24.334 34.1793 24.336 34.346 24.34 34.5C24.3437 34.654 24.3532 34.8207 24.3685 35H11.911L7.33398 39.577ZM14.565 19H30.103V17H14.565V19ZM14.565 27H24.103V25H14.565V27Z'
        fill='#404040'
      />
      <path
        d='M37.3276 28.8011L35.9121 27.4241L29.3351 34.0011L35.9121 40.5781L37.3276 39.2011L33.1776 35.0011L42.9121 35.0011L42.9121 33.0011L33.1776 33.0011L37.3276 28.8011Z'
        fill='#404040'
      />
    </g>
  </svg>
)
